import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { analyticsTrack } from '../../../analyticsUtils';
var DropdownList = /*#__PURE__*/function (_Component) {
  function DropdownList(props) {
    var _this;
    _classCallCheck(this, DropdownList);
    _this = _callSuper(this, DropdownList, [props]);
    _this.state = {
      isExpanded: props.isExpanded
    };
    _this.expand = _this.expand.bind(_this);
    return _this;
  }
  _inherits(DropdownList, _Component);
  return _createClass(DropdownList, [{
    key: "expand",
    value: function expand() {
      var _this$props = this.props,
        location = _this$props.location,
        title = _this$props.title;
      this.setState({
        isExpanded: !this.state.isExpanded
      });
      analyticsTrack('Clicked on dropdown', {
        location: location,
        content: title
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        title = _this$props2.title,
        children = _this$props2.children,
        dropdownClass = _this$props2.dropdownClass,
        titleClass = _this$props2.titleClass,
        isSideBySide = _this$props2.isSideBySide,
        icon = _this$props2.icon,
        extraTitleNode = _this$props2.extraTitleNode;
      var isExpanded = this.state.isExpanded;
      return /*#__PURE__*/React.createElement("div", {
        className: "dropdown"
      }, /*#__PURE__*/React.createElement("div", {
        role: "link",
        tabIndex: 0,
        className: "expand-link ".concat(dropdownClass),
        onClick: function onClick() {
          return _this2.expand();
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "expand-link-container g-row--always ".concat(isSideBySide ? '' : 'g-row--between')
      }, /*#__PURE__*/React.createElement("a", {
        className: "expand-link ".concat(titleClass, " ").concat(isExpanded && 'expanded')
      }, title), /*#__PURE__*/React.createElement("i", {
        className: "fa ".concat(isExpanded ? "fa-".concat(icon, "-up") : "fa-".concat(icon, "-down"), " ms-2")
      }), extraTitleNode)), /*#__PURE__*/React.createElement("div", {
        className: "".concat(isExpanded ? 'show' : 'hide')
      }, children));
    }
  }]);
}(Component);
DropdownList.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isExpanded: PropTypes.bool,
  titleClass: PropTypes.string,
  dropdownClass: PropTypes.string,
  location: PropTypes.string,
  isSideBySide: PropTypes.bool,
  icon: PropTypes.string,
  extraTitleNode: PropTypes.node
};
DropdownList.defaultProps = {
  isExpanded: true,
  dropdownClass: '',
  titleClass: '',
  location: '',
  isSideBySide: false,
  icon: 'chevron',
  extraTitleNode: null
};
export default DropdownList;